import { Injectable } from '@angular/core';
var iobbField: any;
@Injectable()
export class IOBBService {

    constructor() {
        /* empty */
    }

    setIOBB(isProd: boolean) {
        var iobbUrl: string;
        if (isProd) {
            iobbUrl = "https://mpsnare.iesnare.com/snare.js";
        }
        else {
            iobbUrl = "https://ci-mpsnare.iovation.com/snare.js";

        }
        const scriptElement: HTMLScriptElement = document.createElement("script");
        scriptElement.setAttribute("src", iobbUrl);
        document.body.appendChild(scriptElement);
        const inputElement: HTMLInputElement = document.createElement("input");
        inputElement.setAttribute("type", "hidden");
        inputElement.setAttribute("name", "iobb");
        inputElement.setAttribute("id", "iobb");
        document.body.appendChild(inputElement);
    }

    getIOBBValue() {
        iobbField = document.getElementById("iobb") as HTMLInputElement | null;
        return iobbField && iobbField.value ? iobbField.value : "";
    }


}